<template>
    <div>
        <div v-if="preloading">
            <div class="d-flex justify-content-center align-items-center preloading">
                <div class="loader-xl" />
            </div>
        </div>
        <div v-else class="box">
            <TabRapportCommande />
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'
    import TabRapportCommande from '@/components/Admin/RapportCommande/TabRapportCommande'

    export default {
        name: 'RapportCommande',
        title: 'Rapport commandes',
        components: {
            TabRapportCommande
        },
        data: () => ({
            preloading: true
        }),
        created() {
            this.getTranslatedGroups()
            this.getReports()
                .then(() => {})
                .catch(error => {
                    this.$store.dispatch('toastError', error)
                })
                .finally(() => {
                    this.preloading = false
                })
        },
        computed: {
            ...mapState('orders_reports', {
                reports: state => state.reports,
                config: state => state.reportsConfig
            })
        },
        methods: {
            ...mapActions('orders_reports', ['getReports']),
            ...mapActions('group', ['getTranslatedGroups'])
        }
    }
</script>
